<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <template v-if="loading">
          <v-row justify="center" class="mt-8">
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-row>
                <v-col
                  v-for="n in 8"
                  :key="n"
                  cols="6"
                  lg="3"
                  md="4"
                  sm="6"
                  xs="6"
                >
                  <v-skeleton-loader
                    type="image, article"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-else-if="productColors.length == 0">
          <v-row
            justify="center"
            class="search-empty-container"
          >
            <v-col
              cols="12"
              sm="11"
              md="9"
              lg="7"
            >

              <v-card
                class="search-empty-card hover-card"
                elevation="0"
              >

                <div class="search-icon-wrapper">

                  <v-avatar
                    size="110"
                    color="primary lighten-5"
                  >
                    <v-icon
                      size="58"
                      color="primary"
                    >
                      mdi-shopping-search
                    </v-icon>
                  </v-avatar>

                </div>

                <h1 class="search-title">
                  No encontramos productos
                </h1>

                <p class="search-subtitle">
                  No encontramos resultados para tu búsqueda.
                </p>

                <div class="search-keyword">
                  {{ $route.query.q }}
                </div>

                <p class="search-description">
                  Verifica la ortografía o intenta con palabras más generales.
                  También puedes explorar nuestras categorías más populares.
                </p>

                <v-row class="mt-6">

                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-btn
                      block
                      large
                      color="primary"
                      depressed
                      class="search-btn"
                      @click="$router.push({ name:'Products', query: { q: '', orderBy: 'OrderByReleaseDateDESC', page: 1 } })"
                    >
                      VER PRODUCTOS
                    </v-btn>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-btn
                      block
                      large
                      outlined
                      color="primary"
                      class="search-btn"
                      @click="$router.push('/')"
                    >
                      IR AL INICIO
                    </v-btn>
                  </v-col>

                </v-row>

                <v-divider class="my-8"></v-divider>

                <!-- SECTION TITLE -->
                <div class="categories-title">
                  Categorías populares
                </div>

                <!-- CHIPS -->
                <div class="chips-wrapper">

                  <v-chip
                    v-for="cat in categories"
                    :key="cat.id"
                    class="category-chip"
                    color="primary"
                    outlined
                    label
                    @click="redirect(cat.name)"
                  >
                    {{ cat.name }}
                  </v-chip>

                </div>

              </v-card>

            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row justify="center" class="mt-8">
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-row>
                <v-col cols="12" class="d-flex align-end flex-column">
                    <v-select
                      v-model="orderBy"
                      :items="select.filters"
                      item-value="id"
                      item-text="name"
                      label="Ordenar por:"
                      dense
                      outlined
                      @change="changeOrderBy"
                    ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-row>
                <v-col
                  v-for="(item, index) in shownCards"
                  :key="item.id"
                  cols="6"
                  lg="3"
                  md="4"
                  sm="6"
                  xs="6"
                >
                  <v-card class="hover-card">
                    <v-img
                      :src="item.product_color_image[0].image"
                      :key="item.product_color_image[0].image"
                      loading="lazy"
                      :min-height="$vuetify.breakpoint.xsOnly ? 130 : 180"
                      height="auto"
                      @click="productImageSelected(item)"
                      :style="[(item.stock == 0) ? {'filter': 'grayscale(100%)', '-webkit-filter': 'grayscale(100%)'} : {}]"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                      <template v-if="item.stock == 0">
                        <div class="text-right">
                          <v-chip
                            class="ma-2 short"
                            color="pink"
                            label
                            text-color="white"
                          >
                            <v-icon left>
                              mdi-label
                            </v-icon>
                            <b :style="[($vuetify.breakpoint.xsOnly) ? {'font-size': '9px'} : {}]">PRODUCTO AGOTADO</b>
                          </v-chip>
                        </div>
                      </template>
                      <template v-if="item.product.off && !$vuetify.breakpoint.xsOnly">
                        <div class="text-right">
                          <v-chip
                            class="ma-2 short"
                            color="pink"
                            label
                            text-color="white"
                          >
                            <v-icon left>
                              mdi-label
                            </v-icon>
                            <b class="body-2">- {{ item.product.off }}%</b>
                          </v-chip>
                        </div>
                      </template>
                    </v-img>

                    <v-card-title class="justify-center mt-n2">
                      <span class="input-group-product">
                        {{ item.product.group }}
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-row align="center" class="mx-0">
                        <v-rating
                          :value="item.product.average_star ? item.product.average_star : 5"
                          color="secondary"
                          dense
                          half-increments
                          readonly
                          size="16"
                        ></v-rating>
                      </v-row>

                      <div class="my-3 product-name">
                        <span class="input-name-product" @click="productImageSelected(item)">
                          {{ item.product.name }}
                        </span>
                      </div>
                    </v-card-text>

                    <v-card-title class="mt-n10">
                      <v-row no-gutters>
                        <template v-if="item.product.off">
                          <v-col cols="12" sm="12" xs="12">
                            <v-card class="pa-0 ma-0 text-right conetnido" style="border: 0" outlined elevation="0">
                              S/ {{ item.product.sale_price }}
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="12" xs="12">
                            <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ item.product.regular_price }}
                            </v-card>
                          </v-col>
                          <template v-if="$vuetify.breakpoint.xsOnly">
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                                <v-chip
                                  color="pink"
                                  label
                                  text-color="white"
                                >
                                  <v-icon left>
                                    mdi-label
                                  </v-icon>
                                  - {{ item.product.off }}%
                                </v-chip>
                              </v-card>
                            </v-col>
                          </template>
                        </template>
                        <template v-else>
                          <v-col cols="12" sm="12" xs="12">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ item.product.regular_price }}
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="12" xs="12">
                            <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                              &nbsp;
                            </v-card>
                          </v-col>
                          <template v-if="$vuetify.breakpoint.xsOnly">
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                                &nbsp;
                              </v-card>
                            </v-col>
                          </template>
                        </template>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

              <v-row justify="center" class="pt-8 pb-8">
                <v-pagination v-model="page" :length="length" @input="onPageChange"></v-pagination>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'Products',
    components: {
      DefaultLayout
    },
    metaInfo() {
      return {
        title: `${this.$route.query.q} - Dino Toys`,
        meta: [
          { name: 'description', content: 'Lo mejor en ' + this.$route.query.q + ' - Dino Toys' },
          { property: 'og:title', content: this.$route.query.q + ' - Dino Toys' },
          { property: 'og:site_name', content: 'Dino Toys' },
          { property: 'og:description', content: 'Lo mejor en ' + this.$route.query.q },
          { property: 'og:type', content: 'profile' },
          { property: 'og:url', content: 'https://www.dino-toys.com/#/products?q=' + this.$route.query.q },
          { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Flogos%2Flogo_meta.jpg?alt=media&token=4a5db43f-4ff5-4d47-99e4-bea4fab9432b' }
        ]
      }
    },
    data () {
      return {
        loading: false,
        productColors: [],
        page: this.$route.query.page,
        length: null,
        count: 16,
        orderBy: null,
        select: {
          filters: [
            { id: 'OrderByPriceASC', name: 'Precio más bajo' },
            { id: 'OrderByPriceDESC', name: 'Precio más alto' },
            { id: 'OrderByReleaseDateDESC', name: 'Lo más nuevo' },
            { id: 'OrderByBestDiscountDESC', name: 'Mejor descuento' }
          ],
        },
        categories: []
      }
    },
    computed: {
      shownCards () {
        window.scrollTo(0, 0);
        const { page, count, productColors } = this;
        // const number = Math.ceil(productColors.length / count);
        // return productColors.slice((page - 1) * count, page * count);
        return productColors
      }
    },
    methods: {
      findProduct() {
        this.loading = true;
        this.productColors = [];
        const query = this.$route.query.q.concat('', this.orderBy ? '&orderBy=' + this.orderBy : '&orderBy=OrderByReleaseDateDESC').concat('&page=', + this.$route.query.page ? this.$route.query.page : 1);
        const url = process.env.DINO.PATH.GET_PRODUCTS_SEARCH + query;
        axios.get(url)
        .then(response => {
          const page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
          this.productColors = response.data.rows;
          this.length = Math.ceil(response.data.count / this.count);
          this.page = page;
        })
        .catch(err => {

        })
        .finally(() => {
          this.loading = false
        });
      },

      increment(index, item) {
        item.amount = parseInt(item.amount) + 1;
        this.productColors.splice(index, 1, item)
      },

      decrement(index, item) {
        item.amount = parseInt(item.amount) - 1;
        this.productColors.splice(index, 1, item)
      },

      productImageSelected: function(item) {
        this.$router.push({ name: 'ProductDetail', params: { 'productColorId': item.id, 'productId': item.product.id, 'productName': item.product.name } })
      },

      onPageChange: function(page) {
        this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.go(this.$router.currentRoute)
      },

      changeOrderBy: function(value) {
        this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: value, page: this.page } }).catch(err => {});
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.go(this.$router.currentRoute)
      },

      getCategories() {
        this.categories = JSON.parse(localStorage.getItem('moduls'));
        if (!this.categories || this.categories.length === 0) {
          axios.get(process.env.DINO.PATH.GET_MODULS)
          .then(response => {
            this.categories = response.data;
            localStorage.setItem('moduls', JSON.stringify(response.data));
          })
          .catch(err => {
            this.categories = JSON.parse(localStorage.getItem('moduls'));
          });
        }
      },

      redirect: function(group) {
        this.$router.push({ name:'Products', query: { q: group, orderBy: 'OrderByReleaseDateDESC', page: 1 } }).catch(err => {});
      }
    },
    mounted: function() {
      this.orderBy = this.$route.query.orderBy ? this.$route.query.orderBy : 'OrderByReleaseDateDESC';
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
      this.getCategories();
      this.findProduct();
    },
    watch: {
      '$route.query.q'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
      },
      '$route.query.page'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
      },
      '$route.query.orderBy'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
      }
    }
  }
</script>
<style scoped>
  .product-name {
    width: 100%;
    height:45px;
    color:black;
    overflow:hidden;
    text-overflow: ellipsis;
  }

  .btn-add-cart {
    width: 100%;
    font-size: 11px !important
  }

  .input-price >>> input[type='number'] {
    -moz-appearance:textfield;
    text-align: center;
  }

  .input-price >>> input::-webkit-outer-spin-button,
  .input-price >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    text-align: center;
  }

  .input-group-product {
    display: inline-block;
    max-width: 100%;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    color: #64748b;

    background: #f8fafc;
    border: 1px solid #e2e8f0;

    padding: 4px 10px;
    border-radius: 999px;
  }

  .input-name-product {
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    overflow: hidden;

    font-size: 13px;
    font-weight: 500;
    line-height: 1.45;

    /* color: #475569; */

    min-height: 38px;

    cursor: pointer;
    transition: color .2s ease;
  }

  .hover-card {
    transition: all .25s ease;
  }

  .hover-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 30px rgba(0,0,0,.12) !important;
  }

  .conetnido {
    font-size: 90%;
    @media only screen and (min-width: 600px) {
        font-size: 94%;
    }
    @media only screen and (min-width: 1000px) {
        font-size: 98%;
    }
    @media only screen and (min-width: 1200px) {
        font-size: 100%;
    }
  }

  .search-empty-container {
    min-height: 70vh;
    align-items: center;
  }

  .search-empty-card {
    border-radius: 24px;
    padding: 48px 32px;
    text-align: center;
    border: 1px solid #e2e8f0;
    background: #fff;
    box-shadow: 0 15px 40px rgba(15, 23, 42, 0.05);
  }

  .search-icon-wrapper {
    margin-bottom: 24px;
  }

  .search-title {
    font-size: 2rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 10px;
  }

  .search-subtitle {
    color: #64748b;
    margin-bottom: 18px;
  }

  .search-keyword {
    display: inline-block;
    background: #eff6ff;
    color: #2563eb;
    padding: 10px 18px;
    border-radius: 999px;
    font-weight: 600;
    margin-bottom: 24px;
    max-width: 100%;
    word-break: break-word;
  }

  .search-description {
    max-width: 520px;
    margin: auto;
    color: #64748b;
    line-height: 1.8;
  }

  .search-btn {
    height: 50px !important;
    border-radius: 12px;
    text-transform: none !important;
    font-weight: 600;
  }

  .suggestions-title {
    font-size: 1rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 20px;
  }

  .chips-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
  }

  .category-chip {
    transition: all 0.2s ease;
    cursor: pointer;
    font-weight: 500;
  }

  .category-chip:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 600px) {

    .search-empty-card {
      padding: 32px 20px;
      border-radius: 20px;
    }

    .search-title {
      font-size: 1.6rem;
    }

    .search-description {
      font-size: .95rem;
    }

    .search-keyword {
      font-size: .9rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/Products.vue